<template>
	<div>
		<Modal :open-state="open" @close="() => open = false" title="Пополнение баланса" dialog-class="modal__lg">
			<div v-if="isLoaded">
				<div v-if="!isHost2Host" class="fields__item">
					<PaymentSystems v-if="paymentTypes?.length" :items="paymentTypes" :selected-type="selectedType"
						@set-type="selectType" />

					<div class="fields__item">
						<div v-if="isCryptoType && selectedType && selectedType.currency">
							<span class="badge badge--xs badge--lighter">
								1 {{ selectedType.title }} ≈ {{ $root.currency(selectedType.currency) }}
							</span>
						</div>

						<span v-if="selectedType">
							<span class="badge badge--xs badge--lighter">
								Комиссия: {{ selectedType.min_commission }}%
							</span>
							<div v-if="selectedType.min_commission" class="small">
								К оплате с учётом комиссии:
								<b>
									{{ Math.round(amount) + (Math.round(amount) / 100 * selectedType.min_commission) }}
									₽
								</b>
							</div>
						</span>
					</div>

					<div class="fields__item">
						<vue-recaptcha ref="recaptcha" :sitekey="$root.$reCaptchaSiteKey" @verify="onCaptchaVerified"
							@expired="onCaptchaExpired">
						</vue-recaptcha>
					</div>
					
					<div class="fields__item" v-if="isCryptoType">
						<div class="fields__row">
							<div class="fields__item">
								<button @click="deposit" :disabled="!selectedType || disableBtn"
									:class="{'disabled':!selectedType || disableBtn}" class="btn btn--primary btn--block">
									Получить кошелёк
								</button>
							</div>
							<div class="fields__item">
								<input autocomplete="off" class="text-field__input" type="text"
									placeholder="Введите промокод, если есть" v-model="promocode">
							</div>
						</div>
					</div>

					<div v-else class="fields__item">
						<div class="fields__row fields__item">
							<div class="fields__item">
								<div class="text-field">
									<label class="text-field__label">
										Сумма <span v-if="selectedType">от {{ $root.currency(selectedType.min_amount) }}
											до {{ $root.currency(selectedType.max_amount) }}
										</span>
									</label>
									<input autocomplete="off" placeholder="Введите сумму" name="amount"
										class="text-field__input" type="number" v-model="amount">
								</div>
							</div>
							<div class="fields__item">
								<div class="text-field">
									<label class="text-field__label">Промокод</label>
									<input autocomplete="off" class="text-field__input" type="text"
										placeholder="Введите промокод, если есть" name="promo" v-model="promocode">
								</div>
							</div>
						</div>
						<div v-if="amountPresets" class="fields__item">
							<div class="alert alert--warning">Для получения реквизитов попробуйте выбрать сумму из списка ниже
								<div class="field-input__presets">
									<span class="badge badge--primary field-input__preset" v-for="preset in amountPresets" @click="amount = preset">{{preset}}</span>
								</div>
							</div>
						</div>
						<button @click="deposit" :disabled="!selectedType || disableBtn"
							:class="{'disabled':!selectedType || disableBtn}" class="btn btn--primary btn--block">
							Перейти к оплате
						</button>
					</div>

					<div class="alert alert--warning">
						Не создавайте несколько заявок сразу, пополнение может не зачислиться. Если есть проблемы,
						пишите в <a :href="$root.$link.support">техподдержку</a>
					</div>
				</div>
				<div v-if="isHost2Host" class="fields__item">
					<div class="fields__item alert alert--info fields__item" v-if="isCryptoType">
						Обязательно убедитесь, что вы отправляете на данный кошелек
						<b>{{selectedType.title}}</b>
						<div>
							В случае ошибки ваши деньги могут будут утрачены безвозвратно
						</div>
						<div v-if="selectedType.min_amount">
							<div>
								Минимальная сумма: <b>{{selectedType.min_amount}}
									{{selectedType.title}}</b>
							</div>
							<div>
								Переводы меньше <b>{{selectedType.min_amount}}
									{{selectedType.title}}</b> не поступят на баланс
							</div>
						</div>
					</div>
					<div class="fields__item" v-if="isCryptoType && selectedType && selectedType.currency">
						<div class="field-input__label">
							<span class="badge badge--xs badge--lighter">
								1 {{ selectedType.title }} ≈ {{ $root.currency(selectedType.currency) }}
							</span>
						</div>
					</div>
					<div class="card">
						<div class="alert alert--info fields__item" v-if="!isCryptoType">
							Отправьте <b>{{ $root.currency(paymentData.amount) }}</b> на
							указанные ниже реквизиты
						</div>
						<div class="fields__item fields__row fields__row--start">
							<div class="fields__item" v-if="paymentData.number">
								<div class="text-field__label"><b>Реквизиты</b></div>
								<CopyField :text="paymentData.number" />
							</div>
							<div class="fields__item" v-if="paymentData.holder">
								<div class="text-field__label"><b>Получатель</b></div>
								<div>{{ paymentData.holder }}</div>
							</div>
						</div>
						<div class="fields__item fields__row">
							<div class="fields__item" v-if="paymentData.bank">
								<div class="text-field__label"><b>Банк</b></div>
								<div>{{ paymentData.bank_display_name ? paymentData.bank_display_name : paymentData.bank}}</div>
							</div>
							<div class="fields__item" v-if="paymentData.amount && !isCryptoType">
								<div class="text-field__label"><b>Сумма</b></div>
								<CopyField :text="paymentData.amount + ' ₽'" />
							</div>
						</div>
						<div class="fields__item text-center" v-if="isCryptoType && paymentData.number && !isMob">
							<img :src="'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=' + paymentData.number" />
						</div>
						<button class="btn btn--danger btn--lg btn--block" @click="isHost2Host = false">
							Отменить
						</button>
					</div>
				</div>

				<div class="table-wrap" v-if="payments.length">
					<table class="table">
						<tbody>
							<tr v-for="payment in payments">
								<td>
									<div class="lead">{{ payment.id }}</div>
									<div class="lead-sub">{{ payment.date }}</div>
								</td>
								<td>
									<div class="lead">{{ payment.amount }}
										<span class="text-muted">₽</span>
									</div>
									<div class="lead-sub">{{ payment.type }}</div>
								</td>
								<td class="text-right">
									<span v-if="payment.status === 'pending'" class="badge badge--warning badge--md">
										В обработке
									</span>
									<span v-if="payment.status === 'processed'" class="badge badge--success badge--md">
										Выполнено
									</span>
									<span v-if="payment.status === 'failed'" class="badge badge--danger badge--md">
										Отменено
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>

	import PaymentSystems from "../blocks/PaymentSystems.vue";
	import Modal from "../blocks/Modal.vue";
	import breakpointsMixin from '../../mixins/breakpoints-mixin.vue';
	import CopyField from "../blocks/CopyField.vue";
	import VueRecaptcha from './../../components/googlerecaptcha/GoogleReCaptcha.vue';

	const PAYMENT_TYPE_URL = 'url';
    const PAYMENT_TYPE_H2H = 'h2h';

    export default {
		components: {
			PaymentSystems,
			Modal,
			CopyField,
			VueRecaptcha
		},

		mixins: [
			breakpointsMixin
		],

        data() {
            return {
                amount: null,
                promocode: null,
                disableBtn: false,
                payments: [],
                paymentTypes: [],
				cryptoTypes: [],
                selectedType: null,
                isLoaded: false,
                isHost2Host: false,
                paymentData: null,
				open: false,
				gRecaptchaResponse: null,
            }
        },
        mounted() {
            this.getPaymentMethods();
            this.getPayments();
			this.$root.emitter.on('openDeposit', () => this.open = true);
        },

		computed: {
			isCryptoType() {
				return (this.selectedType && this.selectedType.group_code === 'crypto') || (this.isTablet && !this.selectedType);
			},

			amountPresets() {
				if (this.amount && this.selectedType?.min_amount <= this.amount && this.selectedType?.max_amount >= this.amount) {
					let min = this.amount - 20 >= this.selectedType.min_amount;
					let max = this.amount + 20 <= this.selectedType.max_amount;
					return [this.randomInteger(min ? this.amount  -  20 : this.amount + 1, max ? this.amount  +  20: this.amount), this.randomInteger(min ? this.amount  -  20 : this.amount + 1, max ? this.amount  +  20: this.amount), this.randomInteger(min ? this.amount  -  20 : this.amount + 1, max ? this.amount  +  20: this.amount)]
				}
			}
		},

        methods: {
            deposit() {
                if (this.disableBtn) {
                    return;
                }

				if (!this.gRecaptchaResponse) {
					return this.$toast.error('Необходимо пройти капчу');
				}
				
                if(!this.selectedType) {
                    return this.$toast.error('Выберите платежную систему');
                }

				if(this.isCryptoType) {
					this.amount = 5000;
				}

				if(!this.amount) {
                    return this.$toast.error('Введите сумму пополнения');
                }

                this.amount = Math.round(this.amount);

                if(this.amount > this.selectedType.max_amount) {
                    return this.$toast.error(`Максимальная сумма ${this.selectedType.max_amount}`);
                }

                if(this.amount < this.selectedType.min_amount) {
                    return this.$toast.error(`Минимальная сумма ${this.selectedType.min_amount}`);
                }

                this.disableBtn = true;

				this.$root.axios.post('/api/payments/create', {
					amount: this.amount,
					type_id: this.selectedType.id,
					promocode: this.promocode,
					recaptcha: this.gRecaptchaResponse
				}).then(res => {
					const data = res.data;

					if (data.success) {
						switch (data.details.type) {
							case PAYMENT_TYPE_URL:
								window.location.href = data.details.url;
								break;

							case PAYMENT_TYPE_H2H:
								this.isHost2Host = true;
								this.paymentData = data.details;
								break;
						}
					} else {
						this.$toast.error(data.message);
						this.onCaptchaExpired();
					}
				}).catch(error => {
					error = this.$root.graphql.axiosGetError(error);
					this.$toast.error(error);
					this.onCaptchaExpired();
				});

				this.disableBtn = false;
            },
            getPayments() {
                this.$root.axios.get('/api/payments/latest').then(res => {
                    this.payments = res.data;
                    this.isLoaded = true;
                });
            },
            getPaymentMethods() {
                this.$root.axios.get('/api/payments/methods').then(res => {
					this.paymentTypes = res.data;
				});
            },
            selectType(type) {
                this.selectedType = type;
            },
			onCaptchaVerified(response) {
				this.gRecaptchaResponse = response;
			},
			onCaptchaExpired() {
				this.$refs.recaptcha.reset()
			},
			randomInteger(min, max) {
				return Math.floor(min + Math.random() * (max + 1 - min));
			}
        },
        sockets: {
            payment_complete: function() {
                this.getPayments();
            }
        }
    }
</script>